<template>
    <div>
        <div class="row centered"  v-show="project.curriculo.atuacoes">
            <table class="table-responsive highlight striped ">
                <thead>
                    <th>#</th>
                    <th>Tipo de Atuação</th>
                    <th>Quantidade</th>
                    <th>PDF</th>
                    <th>Ações</th>
                </thead>
                <tbody>
                    <tr v-for="(atuacao, index) in atuacoesUsuario" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{atuacao.atuacao['nome']}}</td>
                        <td>{{atuacao['quantidade']}}</td>
                        <td v-if="atuacao['pdf']">
                            {{getNamePdf(atuacao['pdf'])}}
                            <a :href="'/curriculos/atuacoes/pdf/'+atuacao['id']" target='_blank'>
                                (Visualizar PDF)
                            </a>
                        </td>
                        <td v-else-if="!atuacao['pdf']">
                            -
                        </td>
                        <td>
                            <button class="btn red lighten-1" :disabled="!editable"  @click="btnRemoverOnClick($event,atuacao['id'])">Remover</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import {getNamePdf} from '../../utils';
export default {
    name:'Atuacao',
    props:[
        'tipo',
        'editable',
        'atuacaos'
    ],
    data(){
        return{
            atuacoes:JSON.parse(this.atuacaos)
        }

    },
    computed:{
       ...mapState([
            'project'
        ]),
       atuacoesUsuario(){
           return this.$store.getters.atuacoesUsuario(this.$props.tipo);
       },




    },

    methods:{
        ...mapMutations(['setProject']),
        getNamePdf,
        getAtuacao(id){return this.atuacoes.find( atuacao =>atuacao.id == id)},

        btnRemoverOnClick(e,id){
            e.preventDefault();
            let index=this.project.curriculo.atuacoes.findIndex( atuacao => atuacao.id == id);
            if(index > -1){
                showMsg("Atuação removida temporariamente. Para efetivá-las clique em salvar/atualizar",200);
                this.project.curriculo.atuacoes.splice(index,1);
                this.setProject(this.project);

            }


        },


    }

}
</script>
